import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzSubCnld70 } from './pages'

type TIdToPageMapWoofzLove = Record<PageIdWoofzSubCnld70, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_SUB_CNLD_70: TIdToPageMapWoofzLove = {
  [PageId.SUBSCRIPTIONS_CNLD_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_sub_cnld_70/pages/subscriptions/SubscriptionSubCnld70'
      ).then((m) => ({
        default: m.SubscriptionsSubCnld70,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_sub_cnld_70/pages/subscriptions/SubscriptionSubCnld70'
      ),
  },
  [PageId.CHAT_UPSELL_CNLD_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_sub_cnld_70/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_sub_cnld_70/pages/upsell/ChatUpsellNewFlow'),
  },
  [PageId.UPSELL_CNLD_70]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_sub_cnld_70/pages/upsell/Upsell').then(
        (m) => ({
          default: m.Upsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_sub_cnld_70/pages/upsell/Upsell'),
  },
  [PageIdWoofzSubCnld70.DOWNLOAD_CNLD_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_sub_cnld_70/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_sub_cnld_70/pages/download-app/DownloadApp'),
  },
  [PageIdWoofzSubCnld70.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
